import { AccessoryAmount } from '../shared/model/accessory-amount';
import {
  ADD_FREE_ACCESSORY,
  REMOVE_FREE_ACCESSORY,
  UPDATE_AUTO_ELETRIC_FILTER,
  UPDATE_BRANCH_FILTER,
  UPDATE_CUSTOMER_FILTER,
  UPDATE_TECHNICIAN_FILTER,
  UPDATE_APPRAISAL_FILTER,
  UPDATE_ATTENDING_FILTER,
  CLEAN_ACCESSORIES,
  UPDATE_ACCESSORY_LOCAL_FILTER,
  CLEAN_STATE
} from './actions';
import { AutoEletricFilter } from '../shared/filter/auto-eletric-filter';
import { BranchFilter } from '../shared/filter/branch-filter';
import { TechnicianFilter } from '../shared/filter/technician-filter';
import { CustomerFilter } from '../shared/filter/customer-filter';
import { AppraisalFilter } from '../shared/filter/appraisal-filter';
import { AttendingFilter } from '../shared/filter/attending-filter';
import { AccessoryLocalFilter } from '../shared/filter/accessory-local-filter';
import { AccessoryAmountMovement } from '../shared/model/accessory-amount-movement';

export interface ArgosState {
  freeAccessories: Array<any>;
  editedAmounts: Array<any>;
  freeAccessoriesTotal: number;
  autoEletricFilter: AutoEletricFilter;
  branchFilter: BranchFilter;
  customerFilter: CustomerFilter;
  technicianFilter: TechnicianFilter;
  appraisalFilter: AppraisalFilter;
  attendingFilter: AttendingFilter;
  accessoryLocalFilter: AccessoryLocalFilter;
}

export const INITIAL_STATE: ArgosState = {
  freeAccessories: new Array(),
  freeAccessoriesTotal: 0,
  editedAmounts: new Array(),
  autoEletricFilter: new AutoEletricFilter(),
  branchFilter: new BranchFilter(),
  customerFilter: new CustomerFilter(),
  technicianFilter: new TechnicianFilter(),
  appraisalFilter: new AppraisalFilter(),
  attendingFilter: new AttendingFilter(),
  accessoryLocalFilter: new AccessoryLocalFilter()
};

export const rootReducer = (state: ArgosState, action): ArgosState => {
  switch (action.type) {
    case ADD_FREE_ACCESSORY:
      return addFreeAccessory(state, action);
    case REMOVE_FREE_ACCESSORY:
      return removeFreeAccessory(state, action);
    case CLEAN_ACCESSORIES:
      return cleanAccessories(state);
    case UPDATE_AUTO_ELETRIC_FILTER:
      return updateFilter(state, 'autoEletricFilter', action);
    case UPDATE_BRANCH_FILTER:
      return updateFilter(state, 'branchFilter', action);
    case UPDATE_CUSTOMER_FILTER:
      return updateFilter(state, 'customerFilter', action);
    case UPDATE_TECHNICIAN_FILTER:
      return updateFilter(state, 'technicianFilter', action);
    case UPDATE_APPRAISAL_FILTER:
      return updateFilter(state, 'appraisalFilter', action);
    case UPDATE_ATTENDING_FILTER:
      return updateFilter(state, 'attendingFilter', action);
    case UPDATE_ACCESSORY_LOCAL_FILTER:
      return updateFilter(state, 'accessoryLocalFilter', action);
    case CLEAN_STATE:
      return cleanState(state);
    default:
      return state;
  }
};

const cleanAccessories = (state: ArgosState) => {
  const newState = Object.assign({}, state);
  newState.freeAccessories = new Array();
  newState.editedAmounts = new Array();
  newState.freeAccessoriesTotal = 0;
  return newState;
};

const updateFilter = (state: ArgosState, filter, action) => {
  const newState = Object.assign({}, state);
  newState[filter] = action.body.filter;
  return newState;
};

const addFreeAccessory = (state: ArgosState, action) => {
  const originalAmount = action.body;
  const newState = Object.assign({}, state);
  const newAmount = newState.freeAccessories.find(amount => amount.accessoryId === originalAmount.accessory.id);
  updateFreeAccessories(newAmount, newState, originalAmount);
  updateEditedAmounts(newState, originalAmount);
  newState.freeAccessoriesTotal++;
  return newState;
};

const removeFreeAccessory = (state, action) => {
  const newState = Object.assign({}, state);
  newState.freeAccessoriesTotal--;
  const amount = newState.freeAccessories.find(amountToUpdate => amountToUpdate.accessoryId === action.body.accessoryId);
  amount.quantity--;
  return newState;
};

const updateFreeAccessories = (newAmount, newState: ArgosState, originalAmount) => {
  if (newAmount) {
    newAmount.quantity++;
  } else {
    const newAmountMovement = new AccessoryAmountMovement();
    newAmountMovement.accessoryId = originalAmount.accessory.id;
    newAmountMovement.quantity = 1;
    newAmountMovement.accessoryName = originalAmount.accessory.name;
    newState.freeAccessories.push(newAmountMovement);
  }
};

const updateEditedAmounts = (newState: ArgosState, newAmountToUpdate) => {
  const oldAmount = newState.editedAmounts.find(amount => amount.id === newAmountToUpdate.id);
  if (oldAmount) {
    oldAmount.quantity = newAmountToUpdate.quantity;
  } else {
    newState.editedAmounts.push(newAmountToUpdate);
  }
};

const cleanState = (state) => {
  const newState = <ArgosState>{
    freeAccessories: new Array(),
    freeAccessoriesTotal: 0,
    editedAmounts: new Array(),
    autoEletricFilter: new AutoEletricFilter(),
    branchFilter: new BranchFilter(),
    customerFilter: new CustomerFilter(),
    technicianFilter: new TechnicianFilter(),
    appraisalFilter: new AppraisalFilter(),
    attendingFilter: new AttendingFilter(),
    accessoryLocalFilter: new AccessoryLocalFilter()
  };
  return newState;
};



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/core/argos-state.ts